import {
  Button,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SearchIcon from '@material-ui/icons/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FLOOR_CREATE, FLOOR_EDIT, FLOOR_VIEW } from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { deleteAccommodationFloorAPI } from '../../../../../utils/ServicesAPIUtils';
import {
  allFloorsSelector,
  fetchAllAccommodations,
  setAllFloors,
} from '../../../../property/propertySlice';
import { bouquetSelector, fetchAllBouquets } from '../../../../cms/cmsSlice';
import { campainNotificatons } from '../../../../services/servicesSlice';
import './Floor-List.scss';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import WarningPopup from '../../../../../shared/warning-popup/Warning-Popup';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import { isDragDisabled } from '../../../../../utils/formUtils';
import { decryptLocalStorage } from '../../../../../utils/authUtils';

const FloorList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    floorObj: null,
  });
  const originalFloors = useSelector(allFloorsSelector);
  const bouquetList = useSelector(bouquetSelector);
  const allNotificationsOriginal = useSelector(campainNotificatons);
  const [floors, setFloors] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    // assigning data set to local list while keeping an orginal data set for filtering
    setSearchText('');
    setFloors(originalFloors);
    setLoading(false);
  }, [originalFloors]);

  useEffect(() => {
    if (loading || floors?.length === 0) return;
    const totalItems = floors?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [floors?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const handleSearchText = (searchText) => {
    setSearchText(searchText);
    const filteredRows = originalFloors.filter((item) => {
      return item.name.toLowerCase().includes(searchText.toLowerCase());
    });
    onsetPage(0);
    setFloors(filteredRows);
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onOpenDrawer = (event, type) => {
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.floorObj);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      floorObj: null,
    });
  };

  const handleCellMenuClick = (event, floor) => {
    event.stopPropagation();
    setSelectedValue({
      id: floor.id,
      name: floor.name,
      title: '',
      description: '',
      status: false,
      anchorEl: event.currentTarget,
      floorObj: floor,
      warn: false,
    });
  };

  const deleteAccommodationFloor = async (e, name) => {
    e.preventDefault();

    const selectedBouquetFloor = bouquetList?.map((item) => item.floor);
    const selectedNotificationFloor = allNotificationsOriginal?.map((item) => item.residentFloor);

    const showAlertMessage = {
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed',
      warn: false,
    };
    if (
      selectedBouquetFloor.toString().includes(name) &&
      selectedNotificationFloor.toString().includes(name)
    ) {
      showAlertMessage.title = 'Unable to delete';
      showAlertMessage.description =
        'The selected floor cannot be deleted as it has been configured under one or more Notifications and TV Channels-Bouquets';
      showAlertMessage.warn = true;
    } else if (selectedBouquetFloor.toString().includes(name)) {
      showAlertMessage.title = 'Unable to delete';
      showAlertMessage.description =
        'The selected floor cannot be deleted as it has been configured under one or more TV Channels-Bouquets';
      showAlertMessage.warn = true;
    } else if (selectedNotificationFloor.toString().includes(name)) {
      showAlertMessage.title = 'Unable to delete';
      showAlertMessage.description =
        'The selected floor cannot be deleted as it has been configured under one or more Notifications';
      showAlertMessage.warn = true;
    }
    setSelectedValue((prev) => ({
      ...prev,
      title: showAlertMessage.title,
      description: showAlertMessage.description,
      status: true,
      warn: showAlertMessage.warn,
    }));
  };

  const deleteFloor = async () => {
    try {
      const lang = decryptLocalStorage('lang');
      const delByLang = lang !== 'en' ? lang : '';
      if (selectedHotel && selectedValue && selectedValue.id) {
        await deleteAccommodationFloorAPI(selectedHotel, selectedValue.id, delByLang);
        dispatch(fetchAllAccommodations(selectedHotel));
        dispatch(fetchAllBouquets(selectedHotel));
        notificationManager('success', 'Floor deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Floor');
      }
      handleClose();
    }
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      warn: false,
    });
  };

  const onViewDetails = (view, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(FLOOR_VIEW, true, view);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue.floorObj) {
      onViewToggle(FLOOR_VIEW, true, selectedValue.floorObj);
    }
  };

  const getNoOfRooms = (roomRangeList) => {
    let count = 0;
    for (let range of roomRangeList) {
      count = count + range.rangeTo - range.rangeFrom + 1;
    }
    return count;
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const dragDisabled = isDragDisabled(floors, searchText);

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedValue.id && selectedValue.status === true && !selectedValue.warn && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteFloor}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {selectedValue.id && selectedValue.status === true && selectedValue.warn && (
        <WarningPopup warningPopup={selectedValue} onWarningClose={handleClose} warn={true} />
      )}

      <SearchBar
        type={FLOOR_CREATE}
        buttonName='Add Floor'
        displayAddOrEdit={
          permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? 'show'
            : 'hide'
        }
        onOpenDrawer={onOpenDrawer}
        setSearchText={handleSearchText}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={floors}
        setPlaceHolder={setFloors}
        globalPlaceHolder={originalFloors}
        setGlobalPlaceHolder={setAllFloors}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='Accommodations floor'
        module='ACCOMMODATION_FLOOR'
        searchText={searchText}
        setSearch={setSearchText}
        actionMenuItems={[]}
      />

      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          floors && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell className='w-60'>Floor Name</TableCell>
                    <TableCell className='w-30'>No.of Rooms</TableCell>
                    <TableCell align='right' width='20%'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(event, setVisible, floors, setFloors, false, page, rowsPerPage)
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='spas' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? floors.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : floors
                        ).map((floor, i) => (
                          <Draggable
                            key={floor.id}
                            draggableId={floor.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(floor, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell>
                                  {!dragDisabled && (
                                    <DragIndicator className='res-menu-accordion-drag' />
                                  )}
                                </TableCell>
                                <TableCell className='w-60'>{floor?.name}</TableCell>
                                <TableCell className='w-30'>
                                  {getNoOfRooms(floor?.roomRangeList)}
                                </TableCell>
                                <TableCell width='20%' align='right'>
                                  {permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, floor);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === floor.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, FLOOR_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickView(e);
                                      }}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        deleteAccommodationFloor(e, floor.name);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={floors.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
      </div>
    </div>
  );
};

export default FloorList;
